import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import ContactMessageModel from "@/commons/models/ContactMessage";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * 問い合わせメッセージ API 操作クラス
 */
export default class ContactMessages {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * GET ContactMessages
   */
  public async get(userStore: LoginUser, caseId: number): Promise<Array<ContactMessageModel>> {
    const formatParams: any = {
      facilityId: userStore.facility.id,
      caseId: caseId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.ContactMessages, formatParams);
    const response = await this.commonService.executeGet<Array<ContactMessageModel>>(userStore, requestUrl, this.constructor.name, {}, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }

  /**
   * POST ContactMessages
   */
  public async post(userStore: LoginUser, caseId: number, contactMessage: ContactMessageModel): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.facility.id,
      caseId: caseId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.ContactMessages, formatParams);

    // APIのモデルに合わせてここで送信内容を調整
    const requestBody: any = {
      sender: contactMessage.sender,
      senderName: contactMessage.senderName,
      senderType: contactMessage.sendType,
      message: contactMessage.message
    };

    const response = await this.commonService.executePost<any>(userStore, requestUrl, requestBody, this.constructor.name, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}
